import React from 'react';
import RequestsTemplate from '../../templates/Requests/RequestsTemplate';

export default function Requests(props) {
  return <RequestsTemplate {...props} />;
}
